import estimate, { WidgetDevisState } from '@/modules/Home/store/modules/EstimateWidget';
import widgetTravaux, { PreventiveOutState } from '@/modules/Home/store/modules/PreventiveOutWidget';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import widgetFactures, { WidgetFacturesState } from './modules/BillingWidget';
import widgetDemandeIntervention, { InterventionRequestState } from './modules/InterventionRequestWidget';
import widgetPreventif, { PreventiveState } from './modules/PreventiveWidget';
import { mutations } from './mutations';
import { HomeState, state } from './state';

export interface HomeModuleState extends HomeState {
    widgetDevis : WidgetDevisState,
    widgetPreventif: PreventiveState,
    widgetFactures: WidgetFacturesState,
    widgetTravaux: PreventiveOutState,
    widgetDemandeIntervention: InterventionRequestState
}

const module: Module<HomeState, RootState> = {
    modules: {
        widgetTravaux: widgetTravaux,
        widgetPreventif: widgetPreventif,
        widgetDevis: estimate,
        widgetFactures: widgetFactures,
        widgetDemandeIntervention: widgetDemandeIntervention,
    },
    state,
    actions,
    mutations,
    getters,
};

export default module;
export type { HomeState };

